import api from '@/apis/other/notificationAPI.js';
import accountApi from '@/apis/other/accountAPI.js';
import Crud from '@/stores/crudBase';
import NotificationType from '@/commons/wildcards/constants/NotificationType.js';
import NotificationDetailType from '@/commons/wildcards/constants/NotificationDetailType.js';
import SubSystemBusiness from '@/commons/wildcards/constants/SubSystemBusiness.js';
import i18nBaseForm from '@/i18ns/vi/i18nBaseForm';
import Format from '@/commons/wildcards/constants/Format.js';
import {useToast} from 'vue-toast-notification';
import i18nEnum from '../../i18ns/vi/i18nEnum';
import {MSConstant} from '@/commons/wildcards';
import {ModuleContext} from '@/stores/moduleConst.js';
import NoticeType from '@/commons/wildcards/constants/NoticeType.js';
import json from '@/commons/json';
import popupUtil from '@/commons/popupUtil';
import commonFn from '@/commons/commonFunction';
import maintainDatabaseFn from '@/commons/validateMaintainDatabase.js';
import databaseAPI from '@/apis/system/databaseAPI';
import FixValue from '@/commons/wildcards/constants/FixValue';
var crud = new Crud('notification', api);

const state = {
  ...crud.state,
  _config: {
    table: 'notification',
    field: {
      key: 'notification_id',
      check: 'fresh',
    },
  },
  unread: 0,
  model: {},
  push: false,
};
const getters = {
  ...crud.getters,
  unread: state => state.unread,
  push: state => state.push,
  model: state => state.model,
};

/**
 * Custom thông báo
 * modified by: ntloc 2.12.2022
 */
function customNotification(arr, context) {
  //Lấy ra context hiện tại để dùng chung
  const currentContext = context.rootGetters['context/Context'];

  arr.forEach(item => {
    if (item.data) {
      item.targetData = JSON.parse(item.data);

      let formatDate = dte => new Date(dte).toDate(Format.DisplayDate);
      let formatHour = dte => new Date(dte).toDate(Format.TimeNotSecond);
      let errorText = (title, mes) => '<b>{0}: </b>{1}.'.format(title, mes || 'Đã có lỗi xảy ra');

      var clickError = 'Bấm vào đây để';
      switch (item.type) {
        case NotificationType.ShareData:
          item.text = item.targetData.content;
          item.title = item.targetData.content;
          break;
        /** Tính giá xuất kho */
        case NotificationType.CalculatePrice:
          var status = item.targetData.status;

          switch (status) {
            /** Bắt đầu Tính giá xuất kho */
            case NotificationDetailType.CalculatePrice.Start:
              item.text = i18nBaseForm.Notification.StartCalculateExportStock.format(
                formatDate(item.targetData.from_date),
                formatDate(item.targetData.to_date),
              );
              break;

            /** Hoàn thành Tính giá xuất kho */
            case NotificationDetailType.CalculatePrice.Complete:
              item.text = item.targetData.success
                ? i18nBaseForm.Notification.CompleteCalculateExportStock.format(
                    formatDate(item.targetData.from_date),
                    formatDate(item.targetData.to_date),
                  )
                : errorText('Tính giá xuất kho');

              if (!item.targetData.success) {
                item.actions = [
                  {
                    text: 'Xem chi tiết',
                    actionType: MSConstant.NotifyActionType.ViewDetail,
                  },
                ];
              }

              break;
          }
          break;
        /** Thông báo bảo trì */
        case NotificationType.AnnounceUpgrade:
          item.text = i18nBaseForm.Notification.AnnounceUpgrade.format(
            formatHour(item.targetData.from_date),
            formatDate(item.targetData.from_date),
            formatHour(item.targetData.to_date),
            formatDate(item.targetData.to_date),
          );

          item.actions = [
            {
              text: 'Xem chi tiết',
              actionType: MSConstant.NotifyActionType.ViewAnnounce,
            },
          ];
          break;
        /** Ghi sổ bỏ ghi theo lô */
        case NotificationType.PostBath:
          var status = item.targetData.status;
          var type = item.targetData.type;
          var txt = type == NotificationDetailType.PostBath.Type.UnPost ? 'Bỏ ghi' : 'Ghi sổ';
          var subSystems = item.targetData.list_voucher || [];
          var subNames = subSystems
            .map(val => Object.keys(SubSystemBusiness).find(x => SubSystemBusiness[x] == val))
            .map(x => i18nEnum.SubSystemBusiness[x]);

          var names = subNames.join(', ');

          switch (status) {
            /** Bắt đầu */
            case NotificationDetailType.PostBath.Status.Start:
              item.text = i18nBaseForm.Notification.PostbathTypeStatus.format(
                'Bắt đầu',
                txt.toLocaleLowerCase(),
                formatDate(item.targetData.from_date),
                formatDate(item.targetData.to_date),
                names,
              );
              break;

            /** Hoàn thành */
            case NotificationDetailType.PostBath.Status.Complete:
              if (item.targetData.success) {
                item.text = i18nBaseForm.Notification.PostbathTypeStatus.format(
                  'Đã hoàn thành',
                  txt.toLocaleLowerCase(),
                  formatDate(item.targetData.from_date),
                  formatDate(item.targetData.to_date),
                  names,
                );

                /** Nếu có lỗi xảy ra */
                if (item.targetData.number_error) {
                  item.text = [
                    item.text,
                    i18nBaseForm.Notification.ErrorMes.format(txt.toLocaleLowerCase()),
                    'theo lô <br>',
                  ].join(' ');
                }
              } else {
                item.text = errorText(txt);
              }
              if (!item.targetData.success || !!item.targetData.number_error) {
                item.actions = [
                  {
                    text: 'Xem chi tiết',
                    actionType: MSConstant.NotifyActionType.ViewDetail,
                  },
                ];
              }
              break;
          }
          break;

        /** Khóa sổ */
        case NotificationType.CloseBook:
          var status = item.targetData.status;
          switch (status) {
            /** Bắt đầu Khóa sổ */
            case NotificationDetailType.CloseBook.Status.Start:
              item.text = i18nBaseForm.Notification.StartCloseBook;
              break;

            /** Hoàn thành khóa sổ */
            case NotificationDetailType.CloseBook.Status.Complete:
              /** Thành công */
              if (item.targetData.success) {
                item.text = i18nBaseForm.Notification.CompleteCloseBook;
              } else {
                /** Thất bại */
                switch (item.targetData.error_type) {
                  /** Có chứng từ chưa ghi sổ */
                  case NotificationDetailType.CloseBook.ErrorType.NotPosted:
                    item.text = i18nBaseForm.Notification.NotPostedCloseBook;
                    item.actions = [
                      {
                        text: 'Xem chi tiết',
                        actionType: MSConstant.NotifyActionType.ViewDetail,
                      },
                    ];
                    break;

                  /** Có chứng từ ghi sổ trước ngày khóa */
                  case NotificationDetailType.CloseBook.ErrorType.BeforePostedDate:
                  default:
                    item.text = '<b>Khóa sổ không thành công: </b>' + item.targetData.message;
                    break;
                }
              }
              break;
          }
          break;
        case NotificationType.ReBuild:
          var status = item.targetData.status;
          switch (status) {
            /** Bắt đầu bảo trì dữ liệu */
            case NotificationDetailType.MaintainData.Status.Start:
              item.text = i18nBaseForm.Notification.RebuildStatus.format(
                'Bắt đầu',
                formatDate(item.targetData.from_date),
                formatDate(item.targetData.to_date),
              );
              break;
            /** Hoàn thành bảo trì dữ liệu */
            case NotificationDetailType.MaintainData.Status.Complete:
              if (item.targetData.success) {
                item.text = i18nBaseForm.Notification.RebuildStatus.format(
                  'Đã hoàn thành',
                  formatDate(item.targetData.from_date),
                  formatDate(item.targetData.to_date),
                );
                /** Nếu có lỗi xảy ra */
                if (item.targetData.number_error) {
                  item.text = [item.text, '<br>', i18nBaseForm.Notification.ErrorMes.format('bảo trì dữ liệu')].join(
                    ' ',
                  );
                }
              } else {
                item.text = errorText('Bảo trì dữ liệu');
              }
              if (!item.targetData.success || !!item.targetData.number_error) {
                item.actions = [
                  {
                    text: 'Xem chi tiết',
                    actionType: MSConstant.NotifyActionType.ViewDetail,
                  },
                ];
              }
              break;
          }
          break;
        // Chuyển đổi dữ liệu bị lỗi
        case NotificationType.ConvertError:
          var databaseId = JSON.parse(item.data)?.database_id;
          var tenantDatabases = context.rootGetters['context/TenantDatabases'];

          item.text = i18nBaseForm.Notification.ConvertDataError.format(
            JSON.parse(item?.data)?.desktop_database_name ?? '',
            JSON.parse(item?.data)?.desktop_version ?? '',
            commonFn.processXssValue(tenantDatabases.find(x => x.database_id == databaseId)?.database_name ?? ''),
          );
          item.actions = [
            {
              text: 'Thông tin kỹ thuật',
              actionType: MSConstant.NotifyActionType.ViewDetail,
            },
          ];

          break;
        // Kết thúc chuyển đổi dữ liệu
        case NotificationType.EndConvert:
          var databaseId = JSON.parse(item.data)?.database_id;
          var tenantDatabases = context.rootGetters['context/TenantDatabases'];
          var current = context.rootGetters['context/Context'];

          item.text = i18nBaseForm.Notification.CompleteConvertData.format(
            JSON.parse(item?.data)?.desktop_database_name ?? '',
            JSON.parse(item?.data)?.desktop_version ?? '',
            commonFn.processXssValue(tenantDatabases.find(x => x.database_id == databaseId)?.database_name ?? ''),
          );

          item.actions = [
            {
              text: 'Xem chi tiết',
              actionType: MSConstant.NotifyActionType.ViewDetail,
            },
          ];

          // Nếu đang đứng ở dữ liệu chuyển đổi thì mới đối chiếu dữ liệu
          if (current.DatabaseId == databaseId) {
            item.actions.push({
              text: 'Đối chiếu dữ liệu chuyển đổi',
              actionType: MSConstant.NotifyActionType.CompareConvertData,
            });
          }

          break;
        // thông báo sắp hết hạn license
        // ntloc 2.12.2022
        case NotificationType.WarningExpired:
          item.text = i18nBaseForm.Notification.WarningExpiredDate.format(item.targetData.NumberOfDayNearExpired);
          break;
        case NotificationType.EndCreateData:
          let val = JSON.parse(item?.data);
          item.text = i18nBaseForm.Notification.EndCreateData.format(
            commonFn.processXssValue(val?.new_database_name),
            commonFn.processXssValue(val?.old_database_name),
          );
          break;
        case NotificationType.ErrorCreateData:
          item.text = i18nBaseForm.Notification.ErrorCreateData;
          break;
        //Thêm thông báo chuyển chế độ kế toán thành công vào quả chuông
        case NotificationType.ConvertAccountingSystemSuccess:
          item.text = i18nBaseForm.Notification.ConvertAccountingSystemSuccess.format(
            commonFn.processXssValue(item.targetData?.new_database_name),
            commonFn.processXssValue(item.targetData?.old_database_name),
          );

          //Nếu đang ở dữ liệu khác thì sẽ có action Chuyển đến dữ liệu mới
          if (currentContext?.DatabaseId !== item.targetData?.new_database_id) {
            item.actions = [
              {
                text: 'Mở dữ liệu',
                actionType: MSConstant.NotifyActionType.ViewDetail,
              },
            ];
          }
          break;
        //Thêm thông báo chuyển chế độ kế toán thất bại vào quả chuông
        case NotificationType.ConvertAccountingSystemError:
          item.text = i18nBaseForm.Notification.ConvertAccountingSystemError.format(
            commonFn.processXssValue(item.targetData?.new_database_name),
            commonFn.processXssValue(item.targetData?.old_database_name),
          );
          break;
        case NotificationType.Restore:
          if (item.is_success || item.targetData?.is_success) {
            item.text = i18nBaseForm.Notification.CompleteRestoreData.format(
              `${commonFn.processXssValue(item.targetData.database_name)}`,
            );
            item.actions = [
              {
                text: 'Mở dữ liệu',
                actionType: MSConstant.NotifyActionType.ViewDetail,
              },
            ];
          } else {
            item.text = i18nBaseForm.Notification.ErrorRestoreData.format(
              commonFn.processXssValue(item.targetData.database_name),
            );
          }
          break;
        case NotificationType.RestoreStored:
          if (item.is_success || item.targetData?.is_success) {
            item.text = i18nBaseForm.Notification.CompleteRestoreStoredData.format(
              `${commonFn.processXssValue(item.targetData.database_name)}`,
            );
            item.actions = [
              {
                text: 'Mở dữ liệu',
                actionType: MSConstant.NotifyActionType.ViewDetail,
              },
            ];
          } else {
            item.text = i18nBaseForm.Notification.ErrorRestoreStoredData.format(
              commonFn.processXssValue(item.targetData.database_name),
            );
          }
          break;
        case NotificationType.Backup:
          if (item.is_success || item.targetData?.is_success) {
            item.text = i18nBaseForm.Notification.CompleteBackupData.format(
              `${commonFn.processXssValue(item.targetData.database_name)}`,
            );
          } else {
            item.text = i18nBaseForm.Notification.ErrorBackupData.format(
              commonFn.processXssValue(item.targetData.database_name),
            );
          }
          break;

        case NotificationType.Store:
          if (item.is_success || item.targetData?.is_success) {
            item.text = i18nBaseForm.Notification.CompleteStoreData.format(
              `${commonFn.processXssValue(item.targetData.database_name)}`,
            );
          } else {
            item.text = i18nBaseForm.Notification.ErrorStoreData.format(
              commonFn.processXssValue(item.targetData.database_name),
            );
          }
          break;

        case NotificationType.System:
        case NotificationType.Promotion:
          item.title = item.targetData.title;
          item.text = item.targetData.title;
          item.link = item.targetData.button_name ? '' : item.targetData.button_link;

          break;
        case NotificationType.CopyDataStart:
          item.text = i18nBaseForm.Notification.CopyDataStart.format(
            commonFn.processXssValue(item.targetData.from_database_name),
            commonFn.processXssValue(item.targetData.to_database_name),
          );

          break;
        case NotificationType.CopyDataComplete:
          item.text = i18nBaseForm.Notification.CopyDataComplete.format(
            commonFn.processXssValue(item.targetData.from_database_name),
            commonFn.processXssValue(item.targetData.to_database_name),
          );
          item.actions = [
            {
              text: 'Xem chi tiết',
              actionType: MSConstant.NotifyActionType.ViewDetail,
              data: {
                history_copy_data_id: item.targetData.history_copy_data_id,
              },
            },
          ];
          break;
      }
    }
  });
}

/**
 * Xử lý sau khi thêm thông báo
 * @param {*} item
 */
function processWhenPushSuccess(item, context) {
  if (item.data) {
    item.targetData = JSON.parse(item.data);
  }

  //Toast hiển thị bên phải trên, thời gian đóng mặc định
  const config = {...(window._toastConfig || {}), position: 'top-right'};
  const toast = useToast(config);

  //Toast hiển thị chính giữa, thời gian đóng 10s
  const configCustom = {...(window._toastConfig || {}), position: 'top', duration: 10000};
  const toastCustom = useToast(configCustom);

  const formatDate = dte => new Date(dte).toDate(Format.DisplayDate);
  const errorText = (title, mes) => '<b>{0}: </b>{1}'.format(title, mes || 'Đã có lỗi xảy ra');

  switch (item.type) {
    // Sao chép dữ liệu:
    case NotificationType.CopyDataStart:
      toast.success(
        `<div class="ms-toast-content"><div class="ms-toast-text">` +
          i18nBaseForm.Notification.CopyDataStart.format(
            commonFn.processXssValue(item.targetData?.from_database_name),
            commonFn.processXssValue(item.targetData?.to_database_name),
          ) +
          `</div><div class="button icon24 close ms-toast-exit"></div></div>`,
        {
          type: 'CopyData',
        },
      );
      break;
    case NotificationType.CopyDataComplete:
      toast.success(
        `<div class="ms-toast-content"><div class="ms-toast-text">` +
          i18nBaseForm.Notification.CopyDataComplete.format(
            commonFn.processXssValue(item.targetData.to_database_name),
            commonFn.processXssValue(item.targetData.from_database_name),
          ) +
          `<br><span
            class="action-item"
            style="color: #0078d7; cursor: pointer;"
            > Xem chi tiết</span>` +
          `</div><div class="button icon24 close ms-toast-exit"></div></div>`,
        {
          onClick: e => {
            if (e.target?.classList.contains('action-item')) {
              popupUtil.show('CopyDataDetailList', {
                data: {
                  id: item.targetData.history_copy_data_id,
                },
              });
            }
          },
          type: 'CopyData',
        },
      );

      break;
    /** Tính giá xuất kho */
    case NotificationType.CalculatePrice:
      var status = item.targetData.status;
      switch (status) {
        /** Hoàn thành Tính giá xuất kho */
        case NotificationDetailType.CalculatePrice.Complete:
          if (item.targetData.success) {
            toast.success(i18nBaseForm.Notification.CompleteCalculatePrice);
          } else {
            toast.error(errorText('Tính giá xuất kho'));
          }
          break;
      }
      break;

    /** Ghi sổ bỏ ghi theo lô */
    case NotificationType.PostBath:
      var status = item.targetData.status;
      var type = item.targetData.type;
      var txt = type == NotificationDetailType.PostBath.Type.UnPost ? 'Bỏ ghi' : 'Ghi sổ';
      var subSystems = item.targetData.list_voucher || [];
      var subNames = subSystems
        .map(val => Object.keys(SubSystemBusiness).find(x => SubSystemBusiness[x] == val))
        .map(x => i18nEnum.SubSystemBusiness[x]);

      var names = subNames.join(', ');
      switch (status) {
        /** Bắt đầu */
        case NotificationDetailType.PostBath.Status.Start:
          toast.success(
            i18nBaseForm.Notification.PostbathStatus.format(
              'Bắt đầu',
              txt.toLocaleLowerCase(),
              formatDate(item.targetData.from_date),
              formatDate(item.targetData.to_date),
              names,
            ),
          );
          break;

        /** Hoàn thành */
        case NotificationDetailType.PostBath.Status.Complete:
          if (item.targetData.success) {
            var text = i18nBaseForm.Notification.PostbathStatus.format(
              'Đã hoàn thành',
              txt.toLocaleLowerCase(),
              formatDate(item.targetData.from_date),
              formatDate(item.targetData.to_date),
              names,
            );

            /** Nếu có lỗi xảy ra */
            if (item.targetData.number_error) {
              text = [text, i18nBaseForm.Notification.ErrorMes.format(txt.toLocaleLowerCase()), 'theo lô <br>'].join(
                ' ',
              );
            }

            toast.success(text);
          } else {
            toast.error(errorText(txt));
          }

          break;
      }
      break;

    /** Khóa sổ */
    case NotificationType.CloseBook:
      var status = item.targetData.status;
      switch (status) {
        /** Bắt đầu Khóa sổ */
        case NotificationDetailType.CloseBook.Status.Start:
          toast.success(i18nBaseForm.Notification.StartCloseBook);
          break;

        /** Hoàn thành khóa sổ */
        case NotificationDetailType.CloseBook.Status.Complete:
          /** Thành công */
          if (item.targetData.success) {
            toast.success(i18nBaseForm.Notification.CompleteCloseBook);
          } else {
            switch (item.targetData.error_type) {
              /** Có chứng từ chưa ghi sổ */
              case NotificationDetailType.CloseBook.ErrorType.NotPosted:
                toast.error(i18nBaseForm.Notification.NotPostedCloseBook);
                break;

              /** Có chứng từ ghi sổ trước ngày khóa */
              case NotificationDetailType.CloseBook.ErrorType.BeforePostedDate:
              default:
                toast.error(errorText('Khóa sổ không thành công', item.targetData.message));
                break;
            }
          }
          break;
      }
      break;
    /** Bảo trì dữ liệu */
    case NotificationType.ReBuild:
      var status = item.targetData.status;
      switch (status) {
        /** Bắt đầu bảo trì dữ liệu */
        case NotificationDetailType.MaintainData.Status.Start:
          toast.success(
            i18nBaseForm.Notification.RebuildStatus.format(
              'Bắt đầu',
              formatDate(item.targetData.from_date),
              formatDate(item.targetData.to_date),
            ),
          );

          let fromDateMaintain = commonFn.getMoment(item.targetData.from_date).format('YYYY-MM-DD HH:mm:ss');
          let toDateMaintain = commonFn.getMoment(item.targetData.to_date).format('YYYY-MM-DD HH:mm:ss');
          let expried = new Date().addMinutes(10).getTime();

          //NVTUAN1 18.12.2023: Cache lại các thông tin để đánh dấu dữ liệu đang bảo trì dữ liệu không cho thực hiện một số chức năng
          maintainDatabaseFn.setMaintainExpried(expried);
          maintainDatabaseFn.setFormDateMaintain(fromDateMaintain);
          maintainDatabaseFn.setToDateMaintain(toDateMaintain);
          break;

        /** Hoàn thành bảo trì dữ liệu */
        case NotificationDetailType.MaintainData.Status.Complete:
          /** Thành công */
          if (item.targetData.success) {
            var text = i18nBaseForm.Notification.RebuildStatus.format(
              'Đã hoàn thành',
              formatDate(item.targetData.from_date),
              formatDate(item.targetData.to_date),
            );

            /** Nếu có lỗi xảy ra */
            if (item.targetData.number_error) {
              text = [i18nBaseForm.Notification.ErrorMes.format('bảo trì dữ liệu')].join(' ');
            }

            toast.success(text);
          } else {
            toast.error(errorText('Bảo trì dữ liệu'));
          }
          //NVTUAN1 18.12.2023: Clear các thông tin bảo trì dữ liệu để cho thực hiện các chức năng bình thường
          maintainDatabaseFn.clearInfoMaintainDatabase();
          break;
      }
      break;
    /** Chuyển đổi dữ liệu desktop - online  */
    case NotificationType.ConvertError:
      var databaseId = JSON.parse(item.data)?.database_id;
      var current = context.rootGetters['context/Context'];

      if (current.DatabaseId == databaseId) {
        location.reload();
      } else {
        context.commit('context/removeConvertProgress', [{database_id: databaseId}], {root: true});
        context.commit('context/removeDatabaseConverting', [databaseId], {root: true});
        //Cập nhật trạng thái dữ liệu
        updateTenantDatabase(context, databaseId, MSConstant.DatabaseStatus.ConvertError);
      }
      break;
    case NotificationType.EndConvert:
      var databaseId = JSON.parse(item.data)?.database_id;
      var current = context.rootGetters['context/Context'];

      context.commit('context/removeConvertProgress', [{database_id: databaseId}], {root: true});
      context.commit('context/atcDisabledConvert', false, {root: true});
      context.commit('context/removeDatabaseConverting', [databaseId], {root: true});

      if (current.DatabaseId == databaseId) {
        location.reload();
      } else {
        //Cập nhật trạng thái dữ liệu
        updateTenantDatabase(context, databaseId, MSConstant.DatabaseStatus.ShowInClient);
      }
      break;
    /** Tạo dữ liệu từ năm trước */
    case NotificationType.EndCreateData:
      let val = JSON.parse(item?.data);
      let txtCreateData = i18nBaseForm.Notification.EndCreateData.format(
        commonFn.processXssValue(val?.new_database_name),
        commonFn.processXssValue(val?.old_database_name),
      );
      var status = item.targetData.status;
      switch (status) {
        /** Tạo thành công */
        case NotificationDetailType.CreateDataPrevYear.Status.Success:
          if (item.targetData.status) {
            context.commit('context/updateCreateDataProcess', item.targetData, {root: true});
            setTimeout(() => {
              toast.success(txtCreateData);
            }, 2000);
          } else {
            toast.error(errorText('Tạo mới dữ liệu từ năm trước'));
            if (location.href.includes('dictionary/datamanagement')) {
              setTimeout(() => {
                location.reload();
              }, 2000);
            }
          }

          break;
      }
      break;
    //Show toast chuyển chế độ kế toán thành công
    case NotificationType.ConvertAccountingSystemSuccess:
      // toastCustom.success(
      //   i18nBaseForm.Notification.ConvertAccountingSystemSuccess.format(
      //     commonFn.processXssValue(item.targetData?.new_database_name),
      //     commonFn.processXssValue(item.targetData?.old_database_name),
      //   ),
      // );
      //Cập nhật thông tin dữ liệu hiển thị trên màn hình quản lý dữ liệu
      context.commit(
        'context/updateCreateDataProcess',
        {
          DatabaseName: item.targetData?.new_database_name,
          DatabaseShowType: MSConstant.DatabaseShowType.NotData,
          DatabaseStatus: MSConstant.DatabaseStatus.ShowInClient,
          DatabaseId: item.targetData?.new_database_id,
          App: FixValue.AppTT24,
        },
        {root: true},
      );
      //Cập nhật trạng thái dữ liệu
      updateTenantDatabase(context, item.targetData?.new_database_id, MSConstant.DatabaseStatus.ShowInClient);

      //Show popup kết quả chuyển chế độ kế toán nếu đã đóng popup chuyển chế độ kế toán
      if (!popupUtil.checkVisibleName('ConversionOfAccountingSystemPopup')) {
        popupUtil.show('ConversionOfAccountingSystemResultPopup', {
          data: {
            oldDatabaseId: item.targetData?.old_database_id,
            oldDatabaseName: item.targetData?.old_database_name,
            newDatabaseId: item.targetData?.new_database_id,
            newDatabaseName: item.targetData?.new_database_name,
          },
        });
      }

      //Cache lại thông tin getting started cho dữ liệu mới
      commonFn.setLocalStorage(['getting_started', item.targetData?.new_database_id].join('_'), true);

      break;
    //Show toast chuyển chế độ kế toán thất bại
    case NotificationType.ConvertAccountingSystemError:
      toastCustom.error(
        i18nBaseForm.Notification.ConvertAccountingSystemError.format(
          commonFn.processXssValue(item.targetData?.new_database_name),
          commonFn.processXssValue(item.targetData?.old_database_name),
        ),
      );
      //Cập nhật thông tin dữ liệu hiển thị trên màn hình quản lý dữ liệu
      context.commit(
        'context/updateCreateDataProcess',
        {
          DatabaseName: item.targetData?.new_database_name,
          DatabaseShowType: MSConstant.DatabaseShowType.ErrorData,
          DatabaseStatus: MSConstant.DatabaseStatus.Error,
          DatabaseId: item.targetData?.new_database_id,
          App: FixValue.AppTT24,
        },
        {root: true},
      );
      //Cập nhật trạng thái dữ liệu
      updateTenantDatabase(context, item.targetData?.new_database_id, MSConstant.DatabaseStatus.Error);
      break;
    /** Phục hồi dữ liệu */
    case NotificationType.Restore:
      if (item.is_success) {
        //cập nhật lại danh sdachs tenant database
        databaseAPI
          .getDatabases({
            takeAll: true,
          })
          .then(result => {
            //Cập nhật lại danh sách database
            context.commit('context/updateTenantDatabases', result, {root: true});
          });
        toast.success(item.text);
      } else {
        toast.error(item.text);
      }

      break;

    /** Sao lưu dữ liệu */
    case NotificationType.Backup:
      if (item.circular != 'tt23' || item.circular == undefined) {
        if (item.is_success) {
          toast.success(item.text);
        } else {
          toast.error(item.text);
        }
      }
      break;

    /** Lưu trữ dữ liệu */
    case NotificationType.Store:
      if (item.is_success) {
        toast.success(item.text);
      } else {
        toast.error(item.text);
      }
      break;

    /** Lưu trữ dữ liệu */
    case NotificationType.RestoreStored:
      if (item.is_success) {
        toast.success(item.text);
      } else {
        toast.error(item.text);
      }
      break;
  }
}

/**
 * Hàm cập nhật trạng thái của database trong context
 * @param {*} context
 * @param {*} id
 * @param {*} status
 * Created by ntda 29/10/2024
 */
function updateTenantDatabase(context, id, status) {
  //Lấy ra các database hiện có của tenant, call api để lấy dữ liệu mới nhất
  databaseAPI
    .getDatabases({
      takeAll: true,
    })
    .then(res => {
      if (!res || res.length === 0) {
        return;
      }

      //Duyệt tìm database mới để cập nhật trạng thái
      let createDb = res.find(db => db.database_id === id);
      if (createDb) {
        createDb.status = status;
      }

      //Cập nhật lại danh sách database
      context.commit('context/updateTenantDatabases', res, {root: true});
    });
}

/**
 * Lọc thông báo theo loại
 * @returns
 */
function getFilterPayload(payload) {
  var def = [
    {
      field: 'type',
      operator: MSConstant.FilterOperator.In,
      value: [
        /** Tính giá xuất kho */
        MSConstant.NotificationType.CalculatePrice,
        /** Thông báo nâng cấp */
        MSConstant.NotificationType.AnnounceUpgrade,
        /** Ghi sổ theo lô */
        MSConstant.NotificationType.PostBath,
        /** Khóa sổ */
        MSConstant.NotificationType.CloseBook,
        /** Bảo trì dữ liệu */
        MSConstant.NotificationType.ReBuild,
        /** Convert dữ liệu */
        MSConstant.NotificationType.EndConvert,
        MSConstant.NotificationType.ConvertError,
        MSConstant.NotificationType.WarningExpired,
        /** Hệ thống */
        MSConstant.NotificationType.System,
        /** Khuyến mại */
        MSConstant.NotificationType.Promotion,
        /**
         * Lỗi tạo dữ liệu
         */
        MSConstant.NotificationType.ErrorCreateData,
        /**
         * Hoàn thành tạo dữ liệu
         */
        MSConstant.NotificationType.EndCreateData,

        /**
         * Chuyển đổi chế độ kế toán lỗi
         */
        MSConstant.NotificationType.ConvertAccountingSystemError,
        /**
         * Chuyển đổi chế độ kế toán thành công
         */
        MSConstant.NotificationType.ConvertAccountingSystemSuccess,

        // Thông báo Sao chép dữ liệu
        MSConstant.NotificationType.CopyDataStart,
        MSConstant.NotificationType.CopyDataComplete,
        MSConstant.NotificationType.ShareData,

        /**
         * Sao lưu, lưu trữ, phục hồi
         */
        MSConstant.NotificationType.Store,
        MSConstant.NotificationType.RestoreStored,
        MSConstant.NotificationType.Backup,
        MSConstant.NotificationType.Restore,
      ],
    },
  ];

  let concat = payload?.concat || [];
  let over = payload?.overrides || [];

  concat.forEach(x => {
    let item = def.find(o => o.field == x.field);
    item ? (item.value = item.value.concat(x.value)) : def.push(x);
  });

  over.forEach(x => {
    let index = def.findIndex(o => o.field == x.field);
    index > -1 ? (def[index] = x) : def.push(x);
  });

  return JSON.stringify(def);
}

const actions = {
  ...crud.actions,

  /**
   * Lấy dữ liệu thông báo
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getData(context, payload) {
    let res = null;
    let unread = 0;
    payload = payload || {};
    payload.filter = getFilterPayload(payload);
    payload.having = JSON.stringify(payload.filterHaving);

    try {
      context.commit('updateLoading', true);
      let data = await api.getList(payload || {});
      res = data?.Data || [];
      unread = data.Unread || 0;
      customNotification(res, context);
    } finally {
      context.commit('updateLoading', false);
    }

    if (res) {
      context.commit('setModel', {data: res, type: payload.noticeType, first: false});
      if (!payload.noticeType) {
        context.commit('setUnread', unread);
      }
    }

    return res;
  },

  /**
   * Thêm thông báo từ socket
   * @param {*} data
   */
  pushNotification(context, data) {
    /** Xử lý để thêm vào danh sách thông báo */
    customNotification([data], context);
    /** Thêm vào danh sách */
    context.commit('setModel', {data: [data], type: MSConstant.NoticeType.None, first: true});
    context.commit('setUnread', context.state.unread + 1);
    context.commit('setPush');
    /** Xử lý khi thêm */
    processWhenPushSuccess(data, context);
  },

  /**
   * Lấy thông báo chưa đọc
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async unreadNotification(context, payload) {
    let res = null;
    payload = payload || {};
    payload.filter = getFilterPayload();

    try {
      let data = await api.getUnread(payload || {});
      res = data?.Unread || 0;
    } catch (error) {}

    context.commit('setUnread', res);
    return res;
  },

  /**
   * Cập nhật đã đọc
   * @param {*} context
   * @param {*} id
   * @returns
   * modified by ntloc 2.12.2022: truyền vào 1 object với id và context
   */
  async updateRead(context, item) {
    let res = null;
    let id = item.notification_id;

    try {
      res = await api.updateRead(id);
    } catch (error) {}

    if (res) {
      let num = context.state.unread - 1;
      context.commit('setUnread', num > -1 ? num : 0);
      let objContext = {
        id: id,
        item,
        context: context.rootState.context,
      };
      context.commit('updateRead', objContext);
    }
    return res;
  },

  /**
   * Lấy thông báo
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async isMACNotification(context, payload) {
    try {
      await api.isMacNoti(payload);
    } catch {}
  },

  /**
   * Lấy chi tiết thông báo
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getISMACDetail(context, payload) {
    let res = null;

    try {
      res = await api.iSMACDetail(payload || {});
    } catch (error) {
      console.error(`Lỗi lấy thông tin chi tiết thông báo ISMAC: ${payload?.NotificationId}`);
    }

    return res;
  },

  async resetData(context) {
    await context.commit('resetData');
  },
};

/**
 * Add thông báo
 * @param {*} state
 * @param {*} item
 * @param {*} type
 */
function addItem(state, item, type, first) {
  let dt = state.model[type] || [];
  dt.every(o => o.notification_id != item.notification_id) && (first ? dt.unshift(item) : dt.push(item));
  state.model[type] = dt;
}

const mutations = {
  ...crud.mutations,

  /**
   * Cập nhật số thông báo chưa đọc
   * @param {*} state
   * @param {*} data
   */
  setUnread(state, data) {
    state.unread = data;
  },

  /**
   * Cập nhật trạng thái đã đọc
   * @param {*} state
   * @param {*} id
   * modified by ntloc 2.12.2022
   */
  updateRead(state, objContext) {
    objContext.item.fresh = true;
    // check riêng loại thông báo là cảnh báo sắp hết hạn license để cập nhật ngày tắt thông báo
    if (objContext.item.type == 8) {
      let companyCode = objContext.context.BudgetCode;
      let param = {
        company_code: companyCode,
        tenant_id: objContext.context.TenantId,
      };
      accountApi.updateSubsriberReadNotify(param).then(result => {});
    }
  },

  /**
   * Cập nhật số thông báo chưa đọc
   * @param {*} state
   * @param {*} data
   */
  setModel(state, {data, type, first}) {
    type = type || NoticeType.None;

    data.forEach(x => addItem(state, x, type, first));

    if (type == NoticeType.None) {
      let getType = item => {
        switch (item.type) {
          case MSConstant.NotificationType.System:
            return MSConstant.NoticeType.System;
          case MSConstant.NotificationType.Promotion:
            return MSConstant.NoticeType.Promotion;
        }
        return MSConstant.NoticeType.Action;
      };
      data.forEach(x => addItem(state, x, getType(x), first));
    }

    Object.values(state.model).forEach(dt => dt.sortObject('created_date desc'));
  },

  /**
   * Cập nhật số thông báo chưa đọc
   * @param {*} state
   * @param {*} data
   */
  setPush(state) {
    state.push = true;

    setTimeout(() => {
      state.push = false;
    }, 3000);
  },

  resetData(state) {
    state.model = {};
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
